import toast from 'react-hot-toast';

export const navigateToVistProfile = (navigate, id) => {
  navigate(`/admin/practitioners/${id}`);
};

export const copyToClipboard = (navigator, text) => {
  navigator.clipboard.writeText(text);
  toast.success('Copied to clipboard');
};
